module.exports = __webpack_public_path__ + "img/Berliner_Senatsverwaltung_mobileFooter.efd7c548.webp";